<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-row>
            <b-col sm="12">
              <b-card header-bg-variant="primary">
                <div slot="header">
                  <strong>สถิติการบันทึกข้อมูลจำแนกสาขาวิชา</strong>
                </div>
                <h4 align="center">สถิติการบันทึกข้อมูลจำแนกสาขาวิชา 2566 </h4>
                <br>
                <b-row>
                  <b-col lg="2"></b-col>
                  <b-col lg="8">
                    <table border="1" width=100%>
                      <tr class="bg-gray-200">
                        <td rowspan="2" width="25%">
                          <div align=center>สำนักวิชา</div>
                        </td>
<!--                        <td rowspan="2">-->
<!--                          <div align=center>สำนักวิชา</div>-->
<!--                        </td>-->
                        <td rowspan="2" width="30%">
                          <div align=center>สาขาวิชา</div>
                        </td>
                        <td rowspan="2" width="5%">
                          <div align=center >จำนวนผู้มีสิทธิ์เข้ารับพระราชทานปริญญาบัตร</div>
                        </td>
                        <td colspan="3" class="bg-green" width="10%">
                          <div align=center>บันทึกสมบูรณ์</div>
                        </td>
                        <td colspan="2" class="bg-yellow" width="10%">
                          <div align=center>บันทึกไม่สมบูรณ์</div>
                        </td>
                        <td rowspan="2" class="bg-red" width="10%">
                          <div align=center>ยังไม่ได้บันทึก</div>
                        </td>
                      </tr>
                      <tr>
                        <td width="5%" class="bg-green">
                          <div align=center>ป.ตรี</div>
                        </td>
                        <td width="5%" class="bg-green">
                          <div align=center>ป.บัณฑิต</div>
                        </td>
                        <td width="5%" class="bg-green">
                          <div align=center>ร้อยละ</div>
                        </td>
                        <td width="5%" class="bg-yellow">
                          <div align=center>ป.ตรี</div>
                        </td>
                        <td width="5%" class="bg-yellow">
                          <div align=center>ป.บัณฑิต</div>
                        </td>
                      </tr>
                      <tr  v-for="item in items" v-bind:key="item.FACULTYNAME" >
                        <td>
                          <div align=left><font size="-1">{{ item.FACULTYNAME }}</font></div>
                        </td>
                        <td>
                          <div align=left><font size="-1">{{ item.DEPARTMENTNAME }}</font></div>
                        </td>
                        <td>
                          <div align=right>{{ item.TOTAL }} </div>
                        </td>
                        <td>
<!--                          <div align=right v-if="item.COMPLETE3!=0"><a :href="'#/Reportcompleted?level=3&dept='+item.DEPARTMENTCODE+'&group='+item.GROUPID+'&year=2566'"    >-->
<!--                          {{ item.COMPLETE3 }}-->
<!--                        </a></div>-->
                          <div align=right >{{ item.COMPLETE3 }} </div>
                        </td>
                        <td>
<!--                          <div align=right v-if="item.COMPLETE5!=0" ><a :href="'#/Reportcompleted?level=5&dept='+item.DEPARTMENTCODE+'&group='+item.GROUPID+'&year=2566' ">-->
<!--                          {{ item.COMPLETE5 }}-->
<!--                        </a></div>-->
                          <div  align=right > {{ item.COMPLETE5 }} </div>

                        </td>
                        <td bgcolor="#7fffd4"  >
                          <div  align=right >
                          {{ (((item.COMPLETE5 +item.COMPLETE3 )/item.TOTAL )*100 ).toFixed(2)  }}
<!--                          {{ total_per }}-->
                          </div>
                        </td>
                        <td bgcolor="#fafad2"><div align=right v-if="item.INCOMPLETE3!=0" > <a :href="'#/Reportincompleted?level=3&dept='+item.DEPARTMENTCODE +'&group='+item.GROUPID+'&year=2566' ">
                          {{ item.INCOMPLETE3 }}
                        </a></div>
                          <div align=right v-else>{{ item.INCOMPLETE3 }}</div>
                        </td>
                        <td bgcolor="#fafad2"><div align=right v-if="item.INCOMPLETE5!=0" > <a :href="'#/Reportincompleted?level=5&dept='+item.DEPARTMENTCODE +'&group='+item.GROUPID +'&year=2566'">
                          {{ item.INCOMPLETE5 }}
                        </a></div>
                          <div align=right v-else>{{ item.INCOMPLETE5 }}</div>
                        </td>
                        <td bgcolor="#ffe4c4"><div align=right v-if="item.INCOMPLETEALL!=0" ><a :href="'#/Reportnotregis?dept='+item.DEPARTMENTCODE +'&group='+item.GROUPID+'&year=2566'">
                            {{ item.INCOMPLETEALL }}
                        </a></div>
                          <div align=right v-else>
                            {{ item.INCOMPLETEALL }}
                          </div>
                        </td>
                      </tr>
                      <tr bgcolor="#FFFFCC" >
                        <td colspan="2">
                          <div align=center><strong>รวม</strong></div>
                        </td>

                        <td>
                          <div align=right>{{ total.toLocaleString()}}</div>
                        </td>

                        <td>
<!--                          <a :href="'#/Reportcompleted?year=2566&level=3&id=0'">-->
                          <div align=right>{{ total_complete3.toLocaleString() }}</div>
<!--                          </a>-->
                        </td>
                        <td>
<!--                          <a :href="'#/Reportcompleted?year=2566&level=5&id=0'">-->
                          <div align=right>{{ total_complete5.toLocaleString() }}</div>
<!--                          </a>-->
                        </td>
                        <td> <div align=right>  {{ (((total_complete3+total_complete5)/total)*100).toFixed(2) }}</div></td>
                        <td >

<!--                          <a :href="'#/Reportincompleted?year=2566&level=3&id=0'">-->
                          <div align=right>{{ total_incomplete3.toLocaleString() }}</div>
<!--                          </a>-->
                        </td>
                        <td >
<!--                          <a :href="'#/Reportincompleted?year=2566&level=5&id=0'">-->
                          <div align=right>{{ total_incomplete5.toLocaleString() }}</div>
<!--                          </a>-->
                        </td>
                        <td >
<!--                          <a :href="'#/Reportnotregis?year=2566&level=5&id=0'">-->
                            <div align=right>{{ total_incomplete.toLocaleString() }}</div>
<!--                          </a>-->
                        </td>
                      </tr>

                    </table>
                  </b-col>
                  <b-col lg="2"></b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!--      <b-row v-if="stateChart">-->
      <!--        <b-col lg="6">-->
      <!--          <b-card header="กราฟแท่งแสดงการเปรียบเทียบจำนวนบัณฑิตเข้ามาบันทึกข้อมูล">-->
      <!--            <div class="chart-wrapper" align="center">-->
      <!--              <bar-example :chart-data="chart"/>-->
      <!--              <charts/>-->
      <!--            </div>-->
      <!--          </b-card>-->

      <!--        </b-col>-->
      <!--        <b-col lg="6">-->
      <!--          <b-card header="กราฟวงกลมแสดงจำนวนบัณฑิตเข้ามาบันทึกข้อมูลจำแนกตามสำนักวิชา">-->
      <!--            <div class="chart-wrapper" align="center">-->
      <!--              <pie-example :chart-data="pie"/>-->
      <!--              <charts/>-->
      <!--            </div>-->
      <!--          </b-card>-->
      <!--        </b-col>-->
      <!--      </b-row>-->
    </div>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";
import LineExample from "../views/student/LineExample";
import RadarExample from '@/views/charts/RadarExample'
import PieExample from "../views/student/PieExample";
import {hexToRgba} from "@coreui/coreui/dist/js/coreui-utilities";
import BarExample from "../views/student/BarExample";
// import Charts from "@/views/Charts";
import Charts from "../views/student/Charts";

export default {
  components: {
    Charts,
    BarExample,
    YimoVueEditor,
    LineExample,
    RadarExample,
    PieExample,
  },
  name: "CreateGeneral",
  data() {
    return {
      i:0,
      items: [],
      total: 0,
      persent_total: 0,
      total_balance: 0,
      balance: 0,
      count: 0,
      total_complete3: 0,
      total_complete5: 0,
      total_incomplete3: 0,
      total_incomplete5: 0,
      total_incomplete: 0,
      total_per:0,
      sum: 0,
      banlance: 0,
      pie: {
        labels: [],
        datasets: [
          {
            backgroundColor: [

              '#D3D3D3', //ศิล เทา
              '#FFFF00',//วิทยาศาสตร์ เหลือง
              '#00BFFF',//การจัดการ ฟ้า
              '#333366',//เทคโนโลยีสารสนเทศ น้ำเงิน
              '#FF7E9D',//อุตสาหกรรมเกษตร ชมพู
              '#F5F5F5',//นิติศาสต ขาว
              '#FF1493',//วิทยาศาสตร์เครื่องสำอาง บานเย็น
              '#98FB98',//วิทยาศาสตร์สุขภาพ เขียวอ่อน
              '#FF6633',//พยาบาลศาสตร์ แสด
              '#006400',//เวชศาสตร์ชะลอวัยและฟื้นฟูสุขภาพ เขียวเข้ม
              '#288C28',//แพทย์ เขียว
              '#660066',//ทันตแพทยศาสต ม่วงแก่
              '#FFFFCC',//นวัตกรรมสังคม เหลืองนวล
              '#FF0000',//จีนวิทยา แดง
              '#5CEEE6',//การแพทย์บูรณาการ เขียวอมฟ้า
              '#E598BB',

            ],
            data: []
            //  data: [40, 20, 80, 10,40, 20, 80, 10,40, 20, 80, 10,12,14]
          }
        ]


      },
      chart: {
        label: [],
        datasets: [
          {
            label: 'ทั้งหมด',
            backgroundColor: hexToRgba('#006699', 100),
            data: []
          },
          {
            label: 'ยังไม่ได้บันทึก',
            backgroundColor: hexToRgba('#E598BB', 100),
            data: []
          },
          {
            label: 'บันทึกสมบูรณ์',
            backgroundColor: hexToRgba('#7AFFCF', 100),
            data: []
          }
        ]
      },
      stateChart: false
    };
  },

  methods: {
    getStatistic(year) {
      api
        .getStatisticDept(year)
        .then(res => {
          this.items = res.data.data;
          // console.log("x==", this.items)
         for (var i = 0; i < res.data.data.length; i++) {
            // console.log("x==",res.data.data.length)
            // แท่ง
          /*  this.chart.label.push(res.data.data[i].FACULTYNAME);
            this.chart.datasets[0].data.push(res.data.data[i].TOTAL);
            this.chart.datasets[1].data.push(res.data.data[i].INCOMPLETEALL);
            res.data.data[i].SUMCOMPLETE = res.data.data[i].COMPLETE3 + res.data.data[i].COMPLETE5;
            res.data.data[i].COMPLETEPERCEN = (res.data.data[i].SUMCOMPLETE / res.data.data[i].TOTAL) * 100;
            this.chart.datasets[2].data.push(res.data.data[i].SUMCOMPLETE); */
            //ดึงข้อมูลมา sum
            this.total = this.total + res.data.data[i].TOTAL; //จำนวนผู้มีสิทธิ์เข้ารับพระราชทานปริญญาบัตร =ช่องแรก
            this.total_complete3 = this.total_complete3 + res.data.data[i].COMPLETE3;
            this.total_complete5 = this.total_complete5 + res.data.data[i].COMPLETE5;
            this.total_incomplete3 = this.total_incomplete3 + res.data.data[i].INCOMPLETE3;
            this.total_incomplete5 = this.total_incomplete5 + res.data.data[i].INCOMPLETE5;
            this.total_incomplete = this.total_incomplete + res.data.data[i].INCOMPLETEALL;
            // this.total_per= (( res.data.data[i].COMPLETE3 +  res.data.data[i].COMPLETE5 )/res.data.data[i].TOTAL )*100
            //วงกลม
           /* this.pie.labels.push(res.data.data[i].FACULTYNAME);
            this.pie.datasets[0].data.push(res.data.data[i].SUMCOMPLETE);
            if (i == 14) {
              this.pie.labels.push('ยังไม่ได้บันทึก+บันทึกไม่สมบูรณ์');
              this.pie.datasets[0].data.push(this.total_incomplete + this.total_incomplete5 + this.total_incomplete3);
            }*/
          }
          // console.log("total==",this.total)
          // this.total_balance = 3013 - this.total;
          // this.persent_total = (this.total / 3385) * 3013;
          //this.stateChart = true
        })
        .catch(err => {
          console.log("getStatistic", err.toString());
        });
    }
  },
  created() {
    this.getStatistic(2566);
    api.onSetHeader();
  }
};
</script>
<style>
</style>
